import * as actions from './actions'
import { AlertsState } from './model'
import { AlertsActions } from './actions'

const initialState: AlertsState = {
  isBasicAlertsEnabled: false,
  isAPIBasicAlertsEnabled: false,
  isBasicAlertsLimitExceeded: false
}

const reducer = (state: AlertsState = initialState, action: AlertsActions): AlertsState => {
  switch (action.type) {
    case actions.ChangeBasicAlertsEnabled:
      return {
        ...state,
        isBasicAlertsEnabled: action.payload.isBasicAlertsEnabled
      }
    case actions.ChangeBasicAlertsLimitExceeded:
      return {
        ...state,
        isBasicAlertsLimitExceeded: action.payload.isBasicAlertsLimitExceeded
      }

    case actions.ChangeAPIAlertsEnabled:
      return {
        ...state,
        isAPIBasicAlertsEnabled: action.payload.isAPIBasicAlertsEnabled
    }

    default:
      return state
  }
}

export default reducer
